module.exports = __webpack_public_path__ + "img/dream_it_s.1707e1ed.png";